import { render, staticRenderFns } from "./SelectNotification.vue?vue&type=template&id=88a463f4&scoped=true"
import script from "./SelectNotification.vue?vue&type=script&lang=js"
export * from "./SelectNotification.vue?vue&type=script&lang=js"
import style0 from "./SelectNotification.vue?vue&type=style&index=0&id=88a463f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a463f4",
  null
  
)

export default component.exports